import { CSSObject } from "@mantine/core";
import { PickEntityKeys } from "../../utils/type.util";
import { RpiTableColumn } from "./RpiTable";

const DEFAULT_COLUMN_SIZE = 100;

export function createEntityColumn<T extends object, S = string>() {
  return <K extends keyof T = keyof T>(columnDef: RpiTableColumn<PickEntityKeys<T, K>, S>) => columnDef;
}

export function justifyFromAlign<T extends object = any>(
  align: Exclude<RpiTableColumn<T>["align"], undefined>
): CSSObject["justifyContent"] {
  switch (align) {
    case "left":
      return "flex-start";
    case "right":
      return "flex-end";
    case "center":
      return "center";
  }
}

export function getColumnSize<T>(column: RpiTableColumn<T>): number {
  return column.size || DEFAULT_COLUMN_SIZE;
}

// Denominator for the percentage each <th> renders at.
export function getColumnsTotalSize<T>(columns: RpiTableColumn<T>[]): number {
  return columns.reduce((sum, column) => sum + getColumnSize(column), 0);
}
